import { render, staticRenderFns } from "./DoseDetail.vue?vue&type=template&id=47557ac5&"
import script from "./DoseDetail.vue?vue&type=script&lang=js&"
export * from "./DoseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports